<template>
	<div class="unread-staff-modal">
		<div class="modal-title bold18">未読スタッフ</div>

		<ul>
			<li v-for="row in staffs" :key="row.id" class="horizontal-center">
				<avatar :image="row.avatar" :isTeam="false" :width="28"></avatar>
				<span class="">{{ row.name }}</span>
			</li>
		</ul>
	</div>
</template>

<script>
import Avatar from '@/components/Avatar'

export default {
	name: 'UnreadStaffModal',
	components: {
		Avatar,
	},
	props: {
		staffs: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	computed: {
	},
	methods: {
	},
}
</script>

<style lang="scss">

</style>
